import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'

import { ChevronThinRight } from '../../components/Icons'
import { NoticeContainer, Content, IconContainer } from './styles'

class Notice extends Component {
  render() {
    const { notice } = this.props
    if (notice.empty) {
      return <NoticeContainer empty />
    }
    return (
      <Fragment>
        {notice.page !== '' ? (
          <Link to={notice.page}>
            <NoticeContainer>
              <Content>
                {notice.content}
                {notice.subtitle ? <span>{notice.subtitle}</span> : null}
              </Content>
              <IconContainer>
                <ChevronThinRight size="" />
              </IconContainer>
            </NoticeContainer>
          </Link>
        ) : (
          <NoticeContainer noLink>
            <Content>
              {notice.content}
              {notice.subtitle ? <span>{notice.subtitle}</span> : null}
            </Content>
          </NoticeContainer>
        )}
      </Fragment>
    )
  }
}

export default Notice



// WEBPACK FOOTER //
// ./src/components/Notice/index.js